import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import FAQ from './FAQ';
import issueImg from "../images/help-img.avif";
import { Helmet } from "react-helmet-async";

export default function Help() {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  const primaryColor = "#684df4";

  const helpFeatures = [
    {
      icon: "fa-ticket-alt",
      title: "Streamlined Ticketing",
      desc: "Log and track issues instantly with a clean, intuitive system — fast responses and full visibility every step of the way.",
    },
    {
      icon: "fa-headset",
      title: "Tailored Support",
      desc: "Get personalized assistance designed specifically for your institution’s unique workflows and challenges.",
    },
    {
      icon: "fa-chart-line",
      title: "Continuous Improvement",
      desc: "Your feedback directly shapes future updates — share ideas and help us build better software together.",
    },
  ];

  return (
    <div>
      <Helmet>
        <title>Help Center & Support - Technic Mentors</title>
        <link rel="canonical" href="https://technicmentors.com/help/" />
      </Helmet>

      {/* Hero Header */}
      <div className="allHeaderBg">
        <div className="allHeader-overlay d-flex align-items-center justify-content-center">
          <div>
            <h1 className="head text-center text-white animate__animated animate__zoomIn allHeaderP">
              Help Center & Support
            </h1>
          </div>
        </div>
      </div>

      {/* Help Features Cards */}
      <div className="container my-5" data-aos="fade-up" data-aos-duration="1000">
        <div className="section-title text-center mb-5">
          <h2>How We Support You</h2>
        </div>
        <div className="row g-4">
          {helpFeatures.map((item, i) => (
            <div className="col-lg-4 col-md-6" key={i}>
              <div
                className="card shadow-sm h-100 text-center p-4"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '16px',
                  border: '1px solid #e0e0e0',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = primaryColor;
                  e.currentTarget.style.color = '#ffffff';
                  e.currentTarget.style.transform = 'translateY(-12px) scale(1.04)';
                  e.currentTarget.style.boxShadow = '0 25px 60px rgba(0,0,0,0.18)';
                  e.currentTarget.style.borderColor = primaryColor;
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = 'inherit';
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                  e.currentTarget.style.borderColor = '#e0e0e0';
                  const icon = e.currentTarget.querySelector('i');
                  if (icon) icon.style.color = primaryColor;
                }}
              >
                <i
                  className={`fa-solid ${item.icon} fa-4x mb-4`}
                  style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                ></i>
                <h5 className="mb-3 fw-bold">{item.title}</h5>
                <p className="mb-0 small" style={{ lineHeight: 1.6 }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Issue Reporting Section */}
      <div
        className="container-fluid py-5"
        style={{
          background: `linear-gradient(135deg, ${primaryColor}08 0%, #f8f9fa 100%)`,
        }}
        data-aos="fade-up"
        data-aos-duration="1000"
      >
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6" data-aos="fade-right" data-aos-duration="1200">
              <h2 className="mb-4" style={{ fontWeight: 700 }}>
                Uh Oh! <span style={{ color: primaryColor }}>Having an Issue?</span>
              </h2>
              <p className="lead mb-4" style={{ lineHeight: 1.8 }}>
                Run into a glitch or unexpected behavior? Let us know — your feedback helps us fix issues quickly and improve the experience for everyone.
              </p>

              <h5 className="mb-3 fw-bold" style={{ color: primaryColor }}>
                How to Report an Issue:
              </h5>
              <ul className="list-unstyled mb-4" style={{ fontSize: "1.05rem", lineHeight: 1.8 }}>
                <li className="mb-2">→ Briefly describe what went wrong</li>
                <li className="mb-2">→ Include steps to reproduce the issue (if possible)</li>
                <li className="mb-2">→ Copy-paste any error messages or screenshots</li>
              </ul>

              <p className="mb-4">
                Ready? <strong>Generate a support ticket</strong> — our team will guide you through resolution quickly.
              </p>
<Link
  to="/user-login"
  className="primaryBtn px-4 py-2 mb-1 d-inline-block"
>
  Generate Ticket Now &rarr;
</Link>

            </div>

            <div className="col-lg-6" data-aos="fade-left" data-aos-duration="1200">
              <img
                src={issueImg}
                alt="Report an Issue"
                className="img-fluid "
                style={{ borderRadius: "16px" }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <FAQ />
    </div>
  );
}